import { useEffect } from "react";

import { Loader, Stack } from "@braintrust/braintrust-ui-components";
import { Snackbar } from "@js/components/snackbar";
import { LocalStorage } from "@js/services";

import { useNewClientSignUpInvitation } from "../../hooks/new-client-signup-invitation";
import { useSignUpInvitationData } from "../../hooks/sign-up-invitation-data";
import { InvitedByUser } from "../invitation";

export const CreateAccountHeader = () => {
  const referral =
    LocalStorage.getItem(LocalStorage.keys.SIGN_UP_REFERRER) ?? undefined;

  const { isClientInvitation } = useNewClientSignUpInvitation();
  const {
    fetchingPublicInvitationDetails: isLoading,
    publicInvitationDetails,
  } = useSignUpInvitationData({ skip: isClientInvitation });
  const invitationError = publicInvitationDetails?.invitation_error;
  const invitationWithReferral =
    publicInvitationDetails && !invitationError && referral;

  useEffect(() => {
    if (invitationError && referral) {
      Snackbar.error(invitationError, {
        persist: true,
        preventDuplicate: true,
      });

      LocalStorage.removeItem(LocalStorage.keys.SIGN_UP_REFERRER);
    }
  }, [invitationError, referral]);

  return (
    <Stack
      sx={{
        gap: { xs: 1, sm: 1.5 },
        width: "100%",
        mb: invitationWithReferral ? 2 : 0,
      }}
    >
      {isLoading && <Loader />}
      {!isLoading && invitationWithReferral && (
        <InvitedByUser publicInvitationDetails={publicInvitationDetails} />
      )}
    </Stack>
  );
};
